// extracted by mini-css-extract-plugin
export default {"target_purchase":"nZ","btns":"oZ","btn":"pZ","active":"qZ","footer":"rZ"};
    if(module.hot) {
      // 1713996750273
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  